<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>合作企业</h1>
        <p>产学研结合，共创科技未来</p>
      </div>
    </div>
    <div class="main-content">
      <!-- 教授简历头部 -->
      <div class="professor-header">
        <img :src="header.photo" :alt="header.name" class="professor-photo" />
        <div class="professor-info">
          <h1 class="professor-name">{{ header.name }}</h1>
          <p class="professor-title">{{ header.title }}</p>
          <div class="professor-contact">
            <div class="contact-item">
              <span class="contact-label">电话：</span>
              <span>{{ header.phone }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">邮箱：</span>
              <span>{{ header.email }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">办公室：</span>
              <span>{{ header.address }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">办公时间：</span>
              <span>{{ header.workTime }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 教育背景 -->
      <div class="resume-section">
        <h2 class="section-title">教育背景</h2>
        <div class="section-content">
          <div
            class="education-item"
            v-for="(edu, index) in education"
            :key="index">
            <p>{{ edu }}</p>
          </div>
        </div>
      </div>

      <!-- 工作经历 -->
      <div class="resume-section">
        <h2 class="section-title">工作经历</h2>
        <div class="section-content">
          <div
            class="experience-item"
            v-for="(exp, index) in experience"
            :key="index">
            <p>{{ exp }}</p>
          </div>
        </div>
      </div>

      <!-- 研究兴趣 -->
      <div class="resume-section">
        <h2 class="section-title">研究兴趣</h2>
        <div class="section-content">
          <ul class="interest-list">
            <li
              v-for="(item, index) in interests"
              :key="index"
              class="interest-item">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>

      <!-- 代表性论文 -->
      <div class="resume-section">
        <h2 class="section-title">代表性论文</h2>
        <div class="section-content">
          <div
            class="publication-item"
            v-for="(pub, index) in publications"
            :key="index">
            <p>{{ pub }}</p>
          </div>
        </div>
      </div>

      <!-- 科研项目 -->
      <div class="resume-section">
        <h2 class="section-title">科研项目</h2>
        <div class="section-content">
          <div
            class="publication-item"
            v-for="(proj, index) in projects"
            :key="index">
            <p>{{ proj }}</p>
          </div>
        </div>
      </div>

      <!-- 返回按钮 -->
      <router-link to="/team" class="back-button">返回学术团队</router-link>
    </div>

    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
// import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";

import { listUser } from "../../api/team";

export default {
  name: "Resume",
  components: { Header, Nav, Footer },
  data() {
    return {
      header: {
        photo: "",
        name: "",
        title: "",
        phone: "",
        email: "",
        address: "",
        workTime: "",
      },
      education: [],
      experience: [],
      interests: [],
      publications: [],
      projects: [],
      usreInfo: null,
    };
  },
  methods: {
    buildAvatarUrl(path) {
      if (!path) return "";
      if (/^https?:\/\//.test(path)) return path;
      // 头像路径通过 /system 代理访问后端
      // 后端返回的路径格式可能是: profile/avatar/xxx.jpg
      const baseUrl =
        process.env.NODE_ENV === "production"
          ? "https://www.modena-ai.com/system/"
          : "http://localhost:3389/";
      return baseUrl + path.replace(/^\/+/, "");
    },
    async getUserDetail(id) {
      let detailData = {
        userId: id,
      };
      let res = await listUser(detailData);
      if (res.code === 0) {
        let userData = res.rows[0];
        this.header = {
          photo: this.buildAvatarUrl(userData.avatar),
          name: userData.userName,
          title: userData.postGroup,
          phone: userData.phonenumber,
          email: userData.email,
          address: userData.address,
          workTime: userData.workTime,
        };
        this.education = userData.edus;
        this.experience = userData.workExperiences;
        this.interests = userData.researchInterestss;
        this.publications = userData.representTheorys;
        this.projects = userData.scientificResearchs;
      }
    },
  },
  mounted() {
    const id = this.$route.params.id;
    this.getUserDetail(id);
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 0 20px;
}
.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}
.hero-content p {
  font-size: 1.1em;
}

.main-content {
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 40px;
  font-family: "Microsoft YaHei", sans-serif;
  color: #333;
  line-height: 1.6;
}

/* 教授简历头部 */
.professor-header {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
  align-items: center;
}

.professor-photo {
  width: 180px;
  height: 180px;
  object-fit: cover;
  border-radius: 90px;
}

.professor-info .professor-name {
  font-size: 1.8em;
  margin: 0;
}

.professor-title {
  margin: 8px 0 20px;
  font-weight: bold;
}

.professor-contact .contact-item {
  margin-bottom: 6px;
}

.contact-label {
  font-weight: bold;
}

/* 通用板块 */
.resume-section {
  margin-bottom: 40px;
}

.section-title {
  font-size: 1.5em;
  margin-bottom: 15px;
  border-left: 4px solid #004080;
  padding-left: 10px;
}

.section-content p {
  margin: 5px 0;
}

/* 研究兴趣 */
.interest-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.interest-item {
  background-color: #f0f4f8;
  padding: 6px 12px;
  border-radius: 16px;
}

/* 返回按钮 */
.back-button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #004080;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s ease;
}

.back-button:hover {
  background-color: #002d5c;
}

/* ========= 响应式布局 ========= */

/* 平板（小于1200px） */
@media (max-width: 1200px) {
  .partner-item {
    flex: 0 1 calc(50% - 20px); /* ⬅ 两列 */
  }
}

/* 手机（小于768px） */
@media (max-width: 768px) {
  .hero {
    height: 220px;
    padding: 0 15px;
  }
  .hero-content h1 {
    font-size: 2em;
  }
  .hero-content p {
    font-size: 1em;
  }

  .main-content {
    padding: 0 20px;
  }

  .partner-tab {
    padding: 10px 16px;
    font-size: 0.95rem;
  }

  .partner-item {
    flex: 0 1 100%; /* ⬅ 一列 */
    max-width: 100%;
  }

  .partner-logo {
    max-width: 100px;
  }

  .partner-name {
    font-size: 1.1rem;
  }

  .partner-desc,
  .partner-field,
  .partner-period {
    font-size: 0.9rem;
  }
}

/* 超小屏（小于480px） */
@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.6em;
  }
  .partner-tab {
    padding: 8px 12px;
    font-size: 0.85rem;
  }
  .partner-button {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
}
</style>
